import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import PortalCard from "./components/PortalCard";
import "./index.css";
let sample_domain = [
  { name: "Concierge", active: false, url: "https://aiconcierge.io" },
  { name: "User verification", active: false, url: "https://profiletest.io" },
  {
    name: "Travel Tool",
    active: false,
    url: "https://booking.thetravelrobot.com",
  },
  {
    name: "Shop Tool",
    active: false,
    url: "https://cloudmarketplace.io",
  },
  { name: "Community Tool", active: false, url: "https://cloudcommunities.io" },
  { name: "Property reference", active: false, url: "https://rentrobot.io" },
  {
    name: "Property Manager",
    active: false,
    url: "https://properties.ecosystem.co.uk",
  },
  {
    name: "Property Tasks",
    active: false,
    url: "https://taskers.ecosystem.co.uk",
  },
];
class Portals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: true,
      agencies: [],
      brand_name: "",
      brand_url: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        const { domain } = res;
        if (!domain) {
          this.setState({ domain: sample_domain });
        } else this.setState({ domain });
        console.log("brand_data", res);
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });
    }
  }
  activePortal = (index) => {
    let { domain, brand } = this.state;
    domain[index].active = true;
    this.setState({ domain });
    Firebase.updateBrandDataById(brand, { domain: domain });
  };
  showPortals = () => {
    const { domain, brand_name, loading } = this.state;
    return domain.map((item, index) => {
      if (index < 5)
        return (
          <PortalCard
            index={index}
            portal={item}
            brand={brand_name}
            activePortal={() => this.activePortal(index)}
          />
        );
    });
  };
  render() {
    const { username, role, logo, brand, brand_name, is_property_brand } =
      this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <center>
            <h4>
              Access user apps with any mobile number.
              <br /> We issue a 30 day free trial to each user, so it's super
              easy for your and your users to play with the features.
            </h4>
          </center>
          <div className="content">{this.showPortals()}</div>
        </main>
      </div>
    );
  }
}
export default Portals;



// WEBPACK FOOTER //
// ./src/screens/Portals/index.js